import { render, staticRenderFns } from "./InsuranceFlow.vue?vue&type=template&id=579cee1d&scoped=true"
import script from "./InsuranceFlow.vue?vue&type=script&lang=js"
export * from "./InsuranceFlow.vue?vue&type=script&lang=js"
import style0 from "./InsuranceFlow.vue?vue&type=style&index=0&id=579cee1d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "579cee1d",
  null
  
)

export default component.exports